








































import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderDeviceChatCreateStub from '@/components/builder/BuilderDeviceChatCreateStub.vue'
import BuilderDeviceChatBlurredItemStub from '@/components/builder/BuilderDeviceChatBlurredItemStub.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderDeviceFooterStub from '@/components/builder/BuilderDeviceProfileFooterStub.vue'
import BuilderDeviceChatHeaderStub from '@/components/builder/BuilderDeviceChatHeaderStub.vue'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'
import BuilderDeviceChatItemStub from '@/components/builder/BuilderDeviceChatItemStub.vue'
import { Channel } from '@/services/types'
import { Modify } from '@/utils/types'
import BuilderDeviceChatFooterStub from '@/components/builder/BuilderDeviceChatFooterStub.vue'

interface ChannelStub {
  id: number
  stub: true
}

export type CmpChannel = Modify<
  Channel,
  {
    image: string | Blob | File | null
  }
> & {
  highlight: string | null
}

@Component({
  components: {
    BuilderDeviceChatFooterStub,
    BuilderDeviceHighlight,
    BuilderDeviceChatHeaderStub,
    BuilderDeviceFooterStub,
    BuilderDevice,
    BuilderDeviceChatBlurredItemStub,
    BuilderDeviceChatCreateStub,
    BuilderDeviceChatItemStub,
  },
})
export default class BuilderDeviceChatStub extends Vue {
  @Prop({ required: true, type: String }) color!: string

  @Prop({ default: false, type: Boolean }) create!: boolean

  @Prop({ type: String }) siteName!: string | null

  @Prop({ type: String }) headerIcon!: string | null

  @Prop({ type: String }) title!: string

  @Prop({ required: true, type: Array }) chats!: Channel[]
  @Prop({ default: () => [], type: Array }) chatsSource!: Channel[]

  @Prop({ type: String }) highlight!: string | null

  @Prop({ default: true, type: Boolean }) withBlurred!: boolean

  @Prop({ default: false, type: Boolean }) viewMode!: boolean

  get chatList(): (Channel | ChannelStub)[] {
    if (this.chatsSource) {
      for (let i = 0; i < this.chatsSource.length; i++) {
        let image = this.chatsSource[i]?.image
        if (image) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.chats[i].image = image.url
          // this.chats[i].name = this.chatsSource[i].name
        }
      }
    }
    return this.withBlurred
      ? Array.from(new Array(7)).map((_, i) =>
          this.chats[i] ? this.chats[i] : { id: -i, stub: true }
        )
      : this.chats
  }
}
